<template>
    <section>
        <div class="cargando" v-show="cargando">
            <div class="spinner" textosP="2">
                <Loading/>
            </div>
        </div>
        <div class="container" v-show="!cargando">
            <div class="row textosArriba">
                <div class="col-md-6">
                    <div class="titulos">
                        <h1>Get started <b> now</b> </h1>
                        <h5> Elevate your business with a line of credit. Our financial solutions are tailored to your business & personal needs.  </h5> 
                        
                        <div class="ps-3 mt-4 bull">
                            <p><svg style="width:24px;height:24px" viewBox="0 0 24 24">
    <path fill="currentColor" d="M14,2A8,8 0 0,0 6,10A8,8 0 0,0 14,18A8,8 0 0,0 22,10H20C20,13.32 17.32,16 14,16A6,6 0 0,1 8,10A6,6 0 0,1 14,4C14.43,4 14.86,4.05 15.27,4.14L16.88,2.54C15.96,2.18 15,2 14,2M20.59,3.58L14,10.17L11.62,7.79L10.21,9.21L14,13L22,5M4.93,5.82C3.08,7.34 2,9.61 2,12A8,8 0 0,0 10,20C10.64,20 11.27,19.92 11.88,19.77C10.12,19.38 8.5,18.5 7.17,17.29C5.22,16.25 4,14.21 4,12C4,11.7 4.03,11.41 4.07,11.11C4.03,10.74 4,10.37 4,10C4,8.56 4.32,7.13 4.93,5.82Z" />
</svg> Credit lines from 250k up to 5M</p>
                            <p><svg style="width:24px;height:24px" viewBox="0 0 24 24">
                            <path fill="currentColor" d="M14,2A8,8 0 0,0 6,10A8,8 0 0,0 14,18A8,8 0 0,0 22,10H20C20,13.32 17.32,16 14,16A6,6 0 0,1 8,10A6,6 0 0,1 14,4C14.43,4 14.86,4.05 15.27,4.14L16.88,2.54C15.96,2.18 15,2 14,2M20.59,3.58L14,10.17L11.62,7.79L10.21,9.21L14,13L22,5M4.93,5.82C3.08,7.34 2,9.61 2,12A8,8 0 0,0 10,20C10.64,20 11.27,19.92 11.88,19.77C10.12,19.38 8.5,18.5 7.17,17.29C5.22,16.25 4,14.21 4,12C4,11.7 4.03,11.41 4.07,11.11C4.03,10.74 4,10.37 4,10C4,8.56 4.32,7.13 4.93,5.82Z" />
                              </svg> Quick Approval 24 hours</p>
                            <p><svg style="width:24px;height:24px" viewBox="0 0 24 24">
                                    <path fill="currentColor" d="M14,2A8,8 0 0,0 6,10A8,8 0 0,0 14,18A8,8 0 0,0 22,10H20C20,13.32 17.32,16 14,16A6,6 0 0,1 8,10A6,6 0 0,1 14,4C14.43,4 14.86,4.05 15.27,4.14L16.88,2.54C15.96,2.18 15,2 14,2M20.59,3.58L14,10.17L11.62,7.79L10.21,9.21L14,13L22,5M4.93,5.82C3.08,7.34 2,9.61 2,12A8,8 0 0,0 10,20C10.64,20 11.27,19.92 11.88,19.77C10.12,19.38 8.5,18.5 7.17,17.29C5.22,16.25 4,14.21 4,12C4,11.7 4.03,11.41 4.07,11.11C4.03,10.74 4,10.37 4,10C4,8.56 4.32,7.13 4.93,5.82Z" />
                                    </svg> Credit Score NOT determinant</p>
                                <p><svg style="width:24px;height:24px" viewBox="0 0 24 24">
                                    <path fill="currentColor" d="M14,2A8,8 0 0,0 6,10A8,8 0 0,0 14,18A8,8 0 0,0 22,10H20C20,13.32 17.32,16 14,16A6,6 0 0,1 8,10A6,6 0 0,1 14,4C14.43,4 14.86,4.05 15.27,4.14L16.88,2.54C15.96,2.18 15,2 14,2M20.59,3.58L14,10.17L11.62,7.79L10.21,9.21L14,13L22,5M4.93,5.82C3.08,7.34 2,9.61 2,12A8,8 0 0,0 10,20C10.64,20 11.27,19.92 11.88,19.77C10.12,19.38 8.5,18.5 7.17,17.29C5.22,16.25 4,14.21 4,12C4,11.7 4.03,11.41 4.07,11.11C4.03,10.74 4,10.37 4,10C4,8.56 4.32,7.13 4.93,5.82Z" />
                                </svg> No minimun deadlines</p>
                        </div>
                        <div class="sups mt-5">
                            <p>
                                <sup>1</sup>Based on the quality of the property used as collateral and client credit score análisis
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="sec-form">
                        
                        <div class="form" >
                            <form @submit.prevent="mandarForm">
                                <div class="grupoinput">
                                        <label>
                                            <select v-model="mTipoCredito">
                                                <option value="null"><span>Loan type</span></option>
                                                <option value="Simple">Credit Line</option>
                                                <option value="Revolvente">Revolving Credit Line</option>
                                            </select>
                                            <span>Select the best option for you</span>
                                        </label>
                                    </div>
                            <div class="cantidad">
                                     <small>Select or write the</small>
                                <div class="cantidad-header">
                                    <h4>Requested Amount:</h4>
                                    <money class="cantidad-input-label" v-model="mCantidad" v-bind="money" ></money>
                                </div>
                                <div class="slider">
                                    <input type="range" class="rangoinp" min="250000" max="5000000" step="250000" v-model="mCantidad">
                                </div>
                               
                                
                            </div>
                            <div v-if="quieroSimular" class="simulador">
                                <div v-if="formSim">
                                  <div class="cantidad">
                                  <div class="cantidad-header">
                                      <h4>Plazo:</h4>
                                      <money class="cantidad-input-label" v-model="mMeses" v-bind="meses" ></money>
                                  </div>
                                  <div class="slider">
                                      <input type="range" class="rangoinp" min="6" max="36" step="6" v-model="mMeses">
                                  </div>
                                  </div>
                                  <div class="mt-4 mb-4">
                                      <label>¿Cómo es tu historial crediticio?</label>
                                      <div class="d-flex cuentas" >
                                          
                                          <div class="d-flex radios">
                                              <input id="bueno" type="radio" v-model="mInteres" value=".23">
                                              <label for="bueno">Muy bueno</label>
                                          </div>
                                          <div class="d-flex radios">
                                              <input id="Regular" type="radio" v-model="mInteres" value=".27">
                                              <label for="Regular">Regular</label>
                                          </div>
                                          <div class="d-flex radios">
                                              <input id="Malo" type="radio" v-model="mInteres" value=".30">
                                              <label for="Malo">Malo</label>
                                          </div>
                                      </div>
                                  </div>
                                   <div class="errores">
                                  <p>{{errores}}</p>
                                </div>
                                  <div class="grupuinput">
                                      <button type="button" @click="simular">Simular</button>
                                  </div>
                                </div>
                                  <div v-if="simulando">
                                      <LoadPuntos/>
                                  </div>
                                  <div  v-if="showSim">
                                      <h2 class="color-azul " style="font-weight: 300;font-size:20px ;">Tu simulación es:</h2>
                                      <div class="resultado mt-4">
                                          <p>Tu credito de <b>${{formatPrice(mCantidad)}} MXN</b></p>
                                          <p>a plazo de <b>{{mMeses}} Meses</b></p>
                                          <p v-if="resDep == 1">Pagarías <b>${{resultado}}</b> por mes<sup>1</sup></p>
                                          <p v-if="resDep == 2">Pagarías <b>${{interesFinal}} </b>de intereses por mes<sup>1</sup></p>
                                          
                                      </div>
                                      <div class="sups">
                                          <p>
                                              <sup>1</sup> Sujeto a aprobación y propuesta del comité de crédito.
                                          </p>
                                      </div>
                                      <div class="btnsim">
                                        <p @click="volverSimular()">Nueva simulación</p>
                                      </div>
                                  </div>
                            </div>
                            <div class="grupoinput">
                                <label>
                                    <input id="fname" type="text" placeholder="SSN / EIN" v-model="ssn" autocomplete="off" >
                                    <span>SSN / EIN</span>
                                </label>
                            </div>
                           
                            <div class="grupoinput">
                                <label>
                                    <input id="fname" type="text" placeholder="Full Name" v-model="mNombre" autocomplete="off" >
                                    <span>Full Name</span>
                                </label>
                            </div>
                            <div class="grupoinput">
                                <label>
                                    <input id="fname" type="email" placeholder="Email" v-model="mCorreo" autocomplete="off" >
                                    <span>Email</span>
                                </label>
                            </div>
                            <div class="grupoinput">
                                <label>
                                    <input id="fname" type="text" placeholder="Phone Number" v-mask="' (###) - ### - ####'" autocomplete="off" v-model="mTel" >
                                    <span>Phone Number</span>
                                </label>
                            </div>
                            <div class="mb-4">
                                <div class="d-flex cuentas" >
                                    <label>Do you have a real estate collateral?</label>
                                    <div class="d-flex radios">
                                        <input type="radio" v-model="mCheckGarnatia" value="si">
                                        <label for="">Yes</label>
                                    </div>
                                    <div class="d-flex radios">
                                        <input type="radio" v-model="mCheckGarnatia" value="no">
                                        <label for="">No</label>
                                    </div>
                                </div>
                            </div>
                            <div class="grupoinput" v-if="mCheckGarnatia == 'si'">
                                <label>
                                    <select v-model="mGarantia">
                                        <option value="" selected="selected">Type of real estate</option>
                                        <option value="House">House</option>
                                        <option value="Departament">Departament</option>
                                        <option value="Building">Building</option>
                                        <option value="Local">Commercial</option>
                                        <option value="Terrain">Land</option>
                                        <option value="Otro">Otro</option>
                                    </select>
                                    <span>Type of real estate</span>
                                </label>
                            </div>
                            <div class="grupuinput">
                                <button :disabled="!isComplete">CONTINUE</button>
                            </div>
                            <div class="terminos">
                                <p>By clicking CONTINUE you accept our <router-link to="/privacy-policy"> Privacy Notice</router-link>, and use electronic means of identification, such as the verification code.  </p>
                            </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="titulos2">
                        <h5> Obtén un crédito con garantía inmobiliaria por <span>hasta el 50% del valor</span> de tu casa, departamento, oficina o terreno. <sup>1</sup>  </h5> 
                        <h5>Utiliza tu bien inmueble como garantía y obtén liquidez para: </h5>
                        <div class="ps-3 bull">
                            <p><svg style="width:24px;height:24px" viewBox="0 0 24 24">
    <path fill="currentColor" d="M14,2A8,8 0 0,0 6,10A8,8 0 0,0 14,18A8,8 0 0,0 22,10H20C20,13.32 17.32,16 14,16A6,6 0 0,1 8,10A6,6 0 0,1 14,4C14.43,4 14.86,4.05 15.27,4.14L16.88,2.54C15.96,2.18 15,2 14,2M20.59,3.58L14,10.17L11.62,7.79L10.21,9.21L14,13L22,5M4.93,5.82C3.08,7.34 2,9.61 2,12A8,8 0 0,0 10,20C10.64,20 11.27,19.92 11.88,19.77C10.12,19.38 8.5,18.5 7.17,17.29C5.22,16.25 4,14.21 4,12C4,11.7 4.03,11.41 4.07,11.11C4.03,10.74 4,10.37 4,10C4,8.56 4.32,7.13 4.93,5.82Z" />
</svg> Unificar tus deudas</p>
                            <p><svg style="width:24px;height:24px" viewBox="0 0 24 24">
    <path fill="currentColor" d="M14,2A8,8 0 0,0 6,10A8,8 0 0,0 14,18A8,8 0 0,0 22,10H20C20,13.32 17.32,16 14,16A6,6 0 0,1 8,10A6,6 0 0,1 14,4C14.43,4 14.86,4.05 15.27,4.14L16.88,2.54C15.96,2.18 15,2 14,2M20.59,3.58L14,10.17L11.62,7.79L10.21,9.21L14,13L22,5M4.93,5.82C3.08,7.34 2,9.61 2,12A8,8 0 0,0 10,20C10.64,20 11.27,19.92 11.88,19.77C10.12,19.38 8.5,18.5 7.17,17.29C5.22,16.25 4,14.21 4,12C4,11.7 4.03,11.41 4.07,11.11C4.03,10.74 4,10.37 4,10C4,8.56 4.32,7.13 4.93,5.82Z" />
</svg> Capital de trabajo</p>
                            <p><svg style="width:24px;height:24px" viewBox="0 0 24 24">
    <path fill="currentColor" d="M14,2A8,8 0 0,0 6,10A8,8 0 0,0 14,18A8,8 0 0,0 22,10H20C20,13.32 17.32,16 14,16A6,6 0 0,1 8,10A6,6 0 0,1 14,4C14.43,4 14.86,4.05 15.27,4.14L16.88,2.54C15.96,2.18 15,2 14,2M20.59,3.58L14,10.17L11.62,7.79L10.21,9.21L14,13L22,5M4.93,5.82C3.08,7.34 2,9.61 2,12A8,8 0 0,0 10,20C10.64,20 11.27,19.92 11.88,19.77C10.12,19.38 8.5,18.5 7.17,17.29C5.22,16.25 4,14.21 4,12C4,11.7 4.03,11.41 4.07,11.11C4.03,10.74 4,10.37 4,10C4,8.56 4.32,7.13 4.93,5.82Z" />
</svg> Aprovechar oportunidades para tu negocio</p>
                            <p><svg style="width:24px;height:24px" viewBox="0 0 24 24">
    <path fill="currentColor" d="M14,2A8,8 0 0,0 6,10A8,8 0 0,0 14,18A8,8 0 0,0 22,10H20C20,13.32 17.32,16 14,16A6,6 0 0,1 8,10A6,6 0 0,1 14,4C14.43,4 14.86,4.05 15.27,4.14L16.88,2.54C15.96,2.18 15,2 14,2M20.59,3.58L14,10.17L11.62,7.79L10.21,9.21L14,13L22,5M4.93,5.82C3.08,7.34 2,9.61 2,12A8,8 0 0,0 10,20C10.64,20 11.27,19.92 11.88,19.77C10.12,19.38 8.5,18.5 7.17,17.29C5.22,16.25 4,14.21 4,12C4,11.7 4.03,11.41 4.07,11.11C4.03,10.74 4,10.37 4,10C4,8.56 4.32,7.13 4.93,5.82Z" />
</svg> Hacer realidad proyecto que tienes en mente</p>
                        </div>
                        <div class="sups">
                            <p>
                                <sup>1</sup>Sujeto a aprobación y propuesta del comité de crédito.
                            </p>
                        </div>
                    </div>
                </div>
                
            </div>
            
            
        </div>
        
       
    </section>

</template>
<script>
import Loading from '@/components/Loading.vue'
import LoadPuntos from '@/components/Puntos.vue'

import {Money} from 'v-money'
export default {
    components:{
      Loading,Money,LoadPuntos
    },
  data() {
    return {
      mCantidad: 500000,
      quieroSimular:false,
      mNombre:null,
      simulando:false,
      mRfc:'',
      mMeses:12,
      resultado:0,
      interesFinal:0,
      mInteres:0,
      textoBtnSim:"Simular pagos",
      mCorreo:'',
      mTel:'',
      resDep:0,
      meses: {
        prefix: '',
        suffix: '  Meses',
        precision: 0,
        masked: false
      },
      errors:[],
      errores:"",
      ssn:"",
      mCheckGarnatia:null,
      cargando:false,
      mTipoCredito:"null",
      formSim:true,
      showSim:false,
      mGarantia:"",
      mPertenece:"",
      money: {
        decimal: '.',
        thousands: ',',
        prefix: '$ ',
        suffix: ' USD',
        precision: 0,
        masked: false
      }
    }
  },
  methods: {
    formatPrice(value) {
        let val = (value/1).toFixed(2).replace(',', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    simular(){
        if(this.mTipoCredito == "null" || this.mInteres == 0){
          this.errores = "Por favor selecciona:";
          if(this.mInteres == 0){
            this.errores += " tipo de historial crediticio.";
          }
          if(this.mTipoCredito == "null"){
            this.errores += " tipo de crédito";
          }
        }else{
          this.formSim = false
          this.simulando = true
          setTimeout(() => {
            this.simulando = false
            const deseado = this.mCantidad
            const meses = this.mMeses
            const interes = parseFloat(this.mInteres) / 12
            const aPagar = (deseado*interes)/(1-(Math.pow(1 + interes,-meses)))
            if(this.mTipoCredito == "Simple"){
              this.resDep =1
            }else{
              this.resDep =2
            }
            this.interesFinal = this.formatPrice(parseInt(aPagar - (deseado/meses)))
            this.showSim=true
            this.resultado = this.formatPrice(parseInt(aPagar))
              
          }, 2000);  
        }
        
       
        
    },
    showSimluador(){
        if(this.quieroSimular == true){
          this.textoBtnSim = "Simular pagos"
          this.quieroSimular = false
        }else{
          this.textoBtnSim = "Cerrar simulador"
          this.quieroSimular = true
        }
    },
    volverSimular(){
      this.showSim = false
      this.formSim = true
    },
    getKey(){
      var crypto = require('crypto')
      var shasum = crypto.createHash('sha1')
      var dateObj = new Date();
      var month = String(dateObj.getMonth() + 1).padStart(2, '0');
      var day = String(dateObj.getDate()).padStart(2, '0');
      var year = dateObj.getUTCFullYear();
      var completeKey = "credix"+ year + month  + day;
      shasum.update(completeKey)
      let key = shasum.digest('hex')
      return key
    },
    mandarForm(e){
        
        window.scrollTo(0, 0);
        e.preventDefault();
        this.cargando = true
        if(this.mCheckGarnatia == "no"){
              setTimeout(() => {
                          this.$router.push('/no-complete');
                      }, 8000);   
                
              return
            }else{
              /*let solicitud = {
                nombre:this.mNombre,
                correo:this.mCorreo,
                telefono:this.mTel,
                garantia:this.mGarantia,
                pertenece:this.mPertenece,
                cantidad:this.mCantidad,
                tipo:this.mTipoCredito,
                prop:"organico",
                prop2:"Landing"
              } */
              setTimeout(() => {
                      this.$router.push('/complete');
                    }, 5000);
            }
            
    },
    gtag_report_conversion(url) {
      var callback = function () {
        if (typeof(url) != 'undefined') {
          window.location = url;
        }
      };
      this.gtag('event', 'conversion', {
          'send_to': 'AW-941920116/iQRaCPOCg2wQ9J6SwQM',
          'event_callback': callback
      });
      return false;
    }
   },
   computed:{
        isComplete () {
            return (
                this.mCorreo != '' && this.mTel != '' && this.mNombre != '' && this.mCheckGarnatia != null
        )
    }
   },

   mounted(){

        if(this.$route.query.nombre){ this.mNombre = this.$route.query.nombre}
        if(this.$route.query.credito){ this.mTipoCredito = this.$route.query.credito}
        if(this.$route.query.cantidad){ 
            let cantidad = this.$route.query.cantidad;
            cantidad=cantidad.replace("$","");
            cantidad=cantidad.replace(",","");
            cantidad=cantidad.replace(",","");
            cantidad=cantidad.replace(" ","");
            cantidad=cantidad.replace(" ","");
            console.log(cantidad);
            this.mCantidad = parseInt(cantidad)
        }
   }
}
</script>
<style lang="css">
.btnsim p{
  text-align: right;
  font-size: 12px;
  cursor: pointer;
  font-weight: 600;
  color:#006699;
  border-right: 0.7px solid #006699;
  padding-right: 5px;
}
.grupuinput button:disabled{
  cursor: not-allowed;
}
.textosArriba {
  margin-top: 1rem;
}
.textosArriba .titulos h1{
  width: 100%;
}
.sups p {
  color:#999;
  font-size: 7.5pt;
}
.cargando {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 70vh;
}
.titulos2 {
  display: none;
}
.titulos {
  margin-top: 2rem;
}
.titulos sup {
  font-size: 9pt;
}
.titulos h1 {
  width: 70%;
  font-size: 30px;
  font-weight: 500;
  letter-spacing: 0.5px;
  line-height: 52px;
  color: #006699;
}
.titulos h5 {
  font-size: 20px;
  font-weight: 300;
  letter-spacing: 0.5px;
  line-height: 28px;
  color: #201f2d;
}
.titulos h5 span {
  font-weight: bold;
  color: #006699;
}
.titulos .bull svg {
  color: #006699;
}
.sec-form {
  max-width: 500px;
  margin: auto;
  width: 100%;
  transition: all 0.3s;
  padding: 40px 40px 40px 40px;
  border-radius: 16px;
}
.form .cuentas label {
  font-size: 11pt;
}
.form .cuentas .radios {
  margin-left: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.form .cuentas .radios label {
  margin-left: 5px;
  margin-bottom: 0;
}
.form .grupoinput {
  margin-bottom: 1.4rem;
}
.resultado p b{
    color:#006699;
}
.simulador{
  margin-bottom: 2rem;
}
.errores p {
 color:#006699;
}
.form .grupoinput label {
  position: relative;
  display: block;
  background-color: #edf0ef;
  border-radius: 16px;
}
.form .grupoinput label input, .form .grupoinput label select {
  font-size: 12px;
  box-sizing: border-box;
  display: block;
  border: none;
  padding: 20px;
  width: 95%;
  margin-bottom: 20px;
  background: none;
  outline: none;
  transition: all 0.2s ease-in-out;
}
.form .grupoinput label input.rfc, .form .grupoinput label select.rfc {
  letter-spacing: 1.5px;
  text-transform: uppercase;
}
.form .grupoinput label input::placeholder, .form .grupoinput label select::placeholder {
  transition: all 0.2s ease-in-out;
  color: #999;
  font-size: 15px;
}
.form .grupoinput label input:focus, .form .grupoinput label select:focus, .form .grupoinput label input.populated, .form .grupoinput label select.populated {
  padding-top: 28px;
  padding-bottom: 12px;
}
.form .grupoinput label input:focus::placeholder, .form .grupoinput label select:focus::placeholder, .form .grupoinput label input.populated::placeholder, .form .grupoinput label select.populated::placeholder {
  color: transparent;
}
.form .grupoinput label input:focus + span, .form .grupoinput label select:focus + span, .form .grupoinput label input.populated + span, .form .grupoinput label select.populated + span {
  opacity: 1;
  top: 10px;
}
.form .grupoinput label span {
  color: #006699;
  font: 13px Helvetica, Arial, sans-serif;
  position: absolute;
  top: 0px;
  left: 20px;
  opacity: 0;
  transition: all 0.2s ease-in-out;
}
.form button {
  width: 100%;
  font-family: inherit;
  line-height: inherit;
  font-weight: 500;
  cursor: pointer;
  transition-duration: 0.1s;
  transition-property: background-color, color, border-color, opacity, box-shadow;
  transition-timing-function: ease-out;
  outline: none;
  border: 1px solid transparent;
  margin: 0px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 3px 12px 0px;
  padding: 10px 14px;
  min-height: 40px;
  background-color: #006699;
  color: #fff;
  margin: 1rem 0;
  border-radius: 8px;
}
.form button:disabled {
  color: #999;
  background-color: #edf0ef;
}
.form .terminos p {
  font-size: 12px;
  text-align: justify;
  color: #999;
}
.form .terminos p a {
  text-decoration: none;
  color: #006699e3;
}
.cantidad {
  width: 100%;
}
.cantidad-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.cantidad-header h4 {
  font-weight: 300;
  font-size: 12pt;
}
.cantidad-header p {
  font-size: 15pt;
  font-weight: 600;
  color: #006699;
}
.cantidad .rangoinp {
  width: 100%;
  margin-bottom: 1.5rem;
  -webkit-appearance: none;
  height: 3px;
  background: #7dc3e6;
}
.cantidad .rangoinp::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 3px solid #006699;
  cursor: grab;
  background: #fff;
  box-shadow: 1px 1px 1px #006699;
}
.cantidad .rangoinp::-webkit-slider-thumb:active {
  cursor: grabbing;
}

@media only screen and (max-width: 768px) {
  .sec-form {
    padding: 0px 10px 40px 10px;
  }
  .textosArriba {
    margin-top: 0rem;
  }
  .textosArriba .titulos {
    margin-top: 1rem;
  }
  .textosArriba .titulos h1 {
    font-size: 20px;
    text-align: center;
    width: 100%;
  }
  .textosArriba .titulos h5, .textosArriba .titulos .bull, .textosArriba .titulos .sups {
    display: none;
  }
  .titulos2 {
    display: block;
    margin-bottom: 1rem;
  }
  .titulos2 sup {
    font-size: 9pt;
  }
  .titulos2 h5 {
    font-size: 14px;
    font-weight: 300;
    letter-spacing: 0.5px;
    line-height: 28px;
    text-align: justify;
    color: #201f2d;
  }
  .titulos2 h5 span {
    font-weight: bold;
    color: #006699;
  }
  .titulos2 .bull {
    margin-top: 15px;
  }
  .titulos2 .bull p {
    font-size: 12px;
    margin-bottom: 0;
  }
  .titulos2 .bull svg {
    color: #006699;
  }
  .titulos2 .sups p {
    margin-top: 10px;
    font-size: 10px;
  }
}

</style>